import React from "react";
import {__} from "../lib/utility";
import {DealerSearchData} from "../lib/dealer-service";


interface DealerDetailProps{
    dealer:DealerSearchData,
    onClose:Function
}

const DealerDetail:React.FC<DealerDetailProps> = (props) => {
    const dealer = props.dealer;
    return (
        <div className={'dealer-card dealer-detail-card'}>
            <div className={'dealer-card-title'}>
                <h3>{dealer.detail.company}</h3>
            </div>
            <div className={'dealer-card-section'}>
                <div className={'section-title'}>
                    <span className={'label'}>{__('dealer_address')}</span>
                </div>
                <div className={'section-content'}>
                    {dealer.detail.address}<br/>
                    {dealer.detail.zip} {dealer.detail.city}, {dealer.detail.country}
                </div>
            </div>
            <div className={'dealer-card-section'}>
                <div className={'section-title'}>
                    <span className={'label'}>{__('dealer_contact')}</span>
                </div>
                <div className={'section-content'}>
                    {dealer.detail.phone &&
                        <div className={'contact-info'}>
                            <span className={'icon icon-phone'}></span>
                            <span className={'value'}>{dealer.detail.phone}</span>
                        </div>
                    }
                    {dealer.detail.fax &&
                        <div className={'contact-info'}>
                            <span className={'icon icon-phone'}></span>
                            <span className={'value'}>{dealer.detail.fax}</span>
                        </div>
                    }
                    {dealer.detail.email &&
                        <div className={'contact-info'}>
                            <span className={'icon icon-email'}></span>
                            <a href={'mailto:'+dealer.detail.email} target={'_blank'} className={'value'}>
                                {dealer.detail.email}
                            </a>

                        </div>
                    }

                    {dealer.detail.web &&
                        <div className={'contact-info'}>
                            <span className={'icon icon-web'}></span>
                            <a href={dealer.detail.web} target={'_blank'} className={'value'}>
                                {dealer.detail.web}
                            </a>
                        </div>
                    }
                </div>
            </div>
            <div className={'separator'}></div>
            <button className={'dealer-action btn btn-outline'} onClick={()=>props.onClose()}>{__('back')}</button>

        </div>
    )
}

export default DealerDetail;
